import { createStore } from 'vuex'

export default createStore({
    state: {
        tagsList: [],
        collapse: false,
        //判断是否是区域管理员
        isAreaManager: localStorage.getItem("IsAreaManager") === 'true' ? true : false
    },
    mutations: {
        delTagsItem(state, data) {
            state
                .tagsList
                .splice(data.index, 1);
        },
        setTagsItem(state, data) {
            if(data.path.split('#').length==2)data.path=data.path.split('#')[0]
            state
                .tagsList
                .push(data)
        },
        clearTags(state) {
            state.tagsList = []
        },
        closeTagsOther(state, data) {
            state.tagsList = data;
        },
        closeCurrentTag(state, data) {
            for (let i = 0, len = state.tagsList.length; i < len; i++) {
                const item = state.tagsList[i];
                if (item.path === data.$route.fullPath) {
                    if (i < len - 1) {
                        data
                            .$router
                            .push(state.tagsList[i + 1].path);
                    } else if (i > 0) {
                        data
                            .$router
                            .push(state.tagsList[i - 1].path);
                    } else {
                        data
                            .$router
                            .push("/");
                    }
                    state
                        .tagsList
                        .splice(i, 1);
                    break;
                }
            }
        },
        // 侧边栏折叠
        hadndleCollapse(state, data) {
            state.collapse = data;
        },
        //重新赋值是否是区域管理员
        changeIsAreaManager(state) {
            state.isAreaManager = localStorage.getItem("IsAreaManager") === 'true' ? true : false
        }
    },
    actions: {},
    modules: {}
})